module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAgCAYAAAAffCjxAAABR0lEQVRIS6XUO07EMBAG4JmkSo1oEu0NOMCeISXFQsFSJA7USEhcgYIbxE4UiV1ePSXaC1DTcwuUxyBHm4hlvYntuPZ8GlvzDwohHohogYi3cRy/guVBzvk3Ec0QsQaAC8bYs42FQogFEa2JyJWY4zjLKIqeTDGUBZzzcwB47DCbzlpIhZl21kNTsR1oCrYH2WJKyAY7CEksTdMzRFzpjMYgZIKNQrqYFqTCAOCSMbbu5lAbGsOMIBVGRNdJkghjSIGR67o3VlCWZcd1XX8CwEzCiPhmDEmkaZoPIjrZfvSX53lzI+g/gojvvu+fhmH4ow0NIe3zdDbhGKIF6SCjkC4yCJkgByFTRAnZIHuQLbIDTUF6aCrSQkVRHJVluemy83fsdYa1X2yc8zsiut+muM+OCdLW5nk+r6rqBQA2QRBcyQCaIvL+Lwp/RfQf9F9fAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/right.png
// module id = Rii1
// module chunks = 1